import React from "react";
import {useRecoilValue} from "recoil";
import {isDebug} from "./DeveloperUtilsRecoil";
import SuspenseComponent from "../common/SuspenseComponent";

const DebugRecoil = React.lazy(() => import('./DebugRecoil'));

function DebugRecoilWrapper(): React.ReactNode {

    const debug = useRecoilValue(isDebug);
    return (
        <>
            {debug &&  <React.Suspense fallback={<SuspenseComponent/>}>
                <DebugRecoil />
            </React.Suspense>}
        </>
    )
}

export default DebugRecoilWrapper